'use strict';

const _ = require('underscore');
const NodeContentAllocation = require('balus/domain/entity/allocation/node-content');
const Repository = require('balus/domain/repository/allocation/index');
const API = require('balus/infra/api/allocation/node-content');
const ContentFactory = require('data/domain/factory/content/index');
const ContentRepository = require('data/domain/repository/content/index');
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const ElementRepository = require('system/domain/repository/element');

const repositories = {};

class NodeContentRepository extends Repository {
    fetchByNode(node) {
        let allocationJSONs;

        return API.getNextByNode(this._project.id, node.id, 5)
            .then(jsons => {
                allocationJSONs = jsons;
                const contentFactory = new ContentFactory(this._project);

                return Promise.all(
                    _.map(allocationJSONs, aj => contentFactory.build(aj.specific))
                );
            })
            .then(contents => {
                const repo = ContentRepository.find(this._project);
                this.add(_.map(_.zip(contents, allocationJSONs), caj => {
                    const content = caj[0];
                    const aj = caj[1];
                    return new NodeContentAllocation({
                        id: aj.id,
                        model: node,
                        specific: repo.add(content)
                    })
                }));

                return this.getByModel(node);
            });
    }

    fetchByContent(content) {
        let allocationJSONs;
        const context = {
            projectId: this._project.id
        };

        return API.getNextByContent(this._project.id, content.id, 5)
            .then(jsons => {
                allocationJSONs = jsons;
                const nodeJSONs = _.map(allocationJSONs, a => a.model);

                Dispatcher.dispatch({
                    type: Actions.CREATE_NODE,
                    context: context,
                    node: nodeJSONs,
                    options: {fetched: true}
                });
                const nodes = ElementRepository.getNodes({
                    context: context
                });

                this.add(_.map(allocationJSONs, a => {
                    return new NodeContentAllocation({
                        id: a.id,
                        model: nodes.get(a.model.id),
                        specific: content
                    })
                }));

                return this.getBySpecific(content);
            })
    }

    static find(project) {
        let r = repositories[project.id];
        if (!r) {
            r = new NodeContentRepository(project);
            repositories[project.id] = r;
        }
        return r;
    }
}

module.exports = NodeContentRepository;



// WEBPACK FOOTER //
// ./balus/infra/repository/allocation/node-content.js